module.exports = __webpack_public_path__ + "static/media/logo-darkgray.43cd7658.svg";